"use client";

import { ThemeProvider as NextThemesProvider } from "next-themes";
import * as React from "react";

import {
  THEME_STORAGE_KEY,
  defaultThemeId,
  themeIds,
} from "./theme-config";

export default function ThemeProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <NextThemesProvider
      attribute="class" // روی <html> کلاس می‌گذارد
      themes={themeIds}
      defaultTheme={defaultThemeId}
      storageKey={THEME_STORAGE_KEY}
      enableSystem={false}
      disableTransitionOnChange
    >
      {children}
    </NextThemesProvider>
  );
}
